import client from "../client";

export default function API(): Promise<string> {
  return client
    .post(`auth/create_token_invite_friend`)
    .then((response) => response.data);
}
